export default "__VITE_ASSET__16854e5f__"